var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AD244DF7-F87C-441E-9072-3F17CD00ABC5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Jenna-web-interface-menu",
    transform: "translate(-22.000000, -489.000000)",
    fill: "#3778F0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkedin",
    transform: "translate(22.000000, 488.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconmonstr-linkedin-3",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25,0 L3.75,0 C1.67925,0 0,1.67925 0,3.75 L0,14.25 C0,16.32075 1.67925,18 3.75,18 L14.25,18 C16.3215,18 18,16.32075 18,14.25 L18,3.75 C18,1.67925 16.3215,0 14.25,0 Z M6,14.25 L3.75,14.25 L3.75,6 L6,6 L6,14.25 Z M4.875,5.049 C4.1505,5.049 3.5625,4.4565 3.5625,3.726 C3.5625,2.9955 4.1505,2.403 4.875,2.403 C5.5995,2.403 6.1875,2.9955 6.1875,3.726 C6.1875,4.4565 5.60025,5.049 4.875,5.049 Z M15,14.25 L12.75,14.25 L12.75,10.047 C12.75,7.521 9.75,7.71225 9.75,10.047 L9.75,14.25 L7.5,14.25 L7.5,6 L9.75,6 L9.75,7.32375 C10.797,5.38425 15,5.241 15,9.18075 L15,14.25 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.0d12f39767b46094811a06b0ca4a8b3d.svg";
export { ForwardRef as ReactComponent };